import {useId, useState} from "react";
import {useTableOfContents} from "../../hooks/tableOfContentsHooks/useTableOfContents";
import {isNullOrEmpty} from "../../utils/isNullOrEmpty";
import PropTypes from "prop-types";
import useAppModernisation from "../../hooks/useAppModernisation";
import styles from "./TableOfContentsMenu.module.scss";

function TableOfContentsItem({ item }) {
  const tocContext = useTableOfContents();
  const [expanded, setExpanded] = useState(false);
  const hasChildren = item.children && item.children.length > 0;
  const expandId = useId();
  const subItemsId = useId();
  const { isWebModernisationEnabled, isMobileView } = useAppModernisation();

  const toggleExpanded = (e) => {
    e.stopPropagation();
    setExpanded((prev) => !prev);
  };

  const handleClickOnTitle = (e) => {
    e.stopPropagation();
    if (isMobileView) {
      tocContext.closeModal();
      tocContext.setSelectedMenuItem(item);
    } else if (isWebModernisationEnabled) {
      tocContext.setSelectedMenuItem(item);
      tocContext.setActiveItem(item);
    }
  };

  if (isNullOrEmpty(item)) return null;
  let activeItem = tocContext.isActiveItem(item);
  return (
    <li className={styles.item}>
      <div className={styles.itemWrapper}>
        <span className={styles.itemButton} role="button">
          {hasChildren && (
            <i
              id={expandId}
              className={`tg-icons-Chevron${expanded ? "Up" : "Down"}`}
              onClick={toggleExpanded}
              aria-expanded={expanded}
              aria-label={`Expand Children for: ${item.title}`}
              aria-controls={subItemsId}
            ></i>
          )}
        </span>
        <span
          className={`${styles.itemText} ${activeItem ? styles.active : ""}`}
          onClick={handleClickOnTitle}
          role="button"
          aria-current={activeItem}
        >
          {item.title}
        </span>
      </div>

      {hasChildren && expanded && (
        <ul id={subItemsId}>
          {item.children.map((child) => (
            <TableOfContentsItem key={child.id} item={child} />
          ))}
        </ul>
      )}
    </li>
  );
}

TableOfContentsItem.propTypes = {
  item: PropTypes.object.isRequired,
};


export default TableOfContentsItem;